import type { ExportAssetType } from '../../util/useAddPermissions';

/** Types for which IP Address (or Collector IP) is not bulk-editable. */
const IP_NON_EDITABLE_TYPES: ExportAssetType[] = [
  'compute',
  'network',
  'application',
  'asset_management',
  'analyzer_management',
  'virtualization',
  'env',
  'control',
];

/** Security application subtypes that have api_url non-editable. */
const SECURITY_API_URL_SUBTYPES = new Set([
  'trellix_epo',
  'claroty',
  'nozomi',
  'veeam',
  'whatsup_gold',
]);

/**
 * Returns the set of field names that must not be bulk-editable for the given
 * asset type and (when relevant) single selected subtype.
 * Used by BulkEditTab to grey out fields per spec tables.
 */
export function getBulkNonEditableFields(
  type: ExportAssetType,
  singleSubtype: string | null
): Set<string> {
  const out = new Set<string>(['name', 'syslog_host']);

  if (IP_NON_EDITABLE_TYPES.includes(type)) {
    out.add('ip_address');
  }

  if (type === 'dcs_plc' && singleSubtype === 'hmi_stn') {
    out.add('device_ip_address');
  }

  if (type === 'application' && singleSubtype) {
    if (SECURITY_API_URL_SUBTYPES.has(singleSubtype)) {
      out.add('api_url');
    }
    if (singleSubtype === 'wsus') {
      out.add('database_ip');
      out.add('database_port');
    }
  }

  if (type === 'control') {
    out.add('ip_address');
    out.add('ip_addresses');
  }

  return out;
}
